import { SearchInput } from "@volca/ui/components/ui/search-input";
import { Stack } from "@volca/ui/components/ui/stack";
import { TeamFilter } from "@/payroll/teams/team-filter";
import { RosterFilterControls } from "./roster-filter-controls";
import type {
  PayrollTeam,
  PayrollRosterFilterField,
  PayrollRosterFieldFilters,
} from "./types";

interface RosterDisplayControlsProps {
  filterFields: PayrollRosterFilterField[];
  teams: PayrollTeam[];
  teamIds: string[];
  onTeamIdsChange: (ids: string[]) => void;
  search: string;
  filters: PayrollRosterFieldFilters;
  onSearchChange: (search: string) => void;
  onFiltersChange: (filters: PayrollRosterFieldFilters) => void;
}

export const RosterDisplayControls = ({
  filterFields,
  teams,
  teamIds,
  onTeamIdsChange,
  search,
  filters,
  onSearchChange,
  onFiltersChange,
}: RosterDisplayControlsProps) => (
  <Stack
    direction="row"
    align="start"
    gap={2}
    className="w-full shrink-0 flex-wrap"
  >
    <SearchInput
      value={search}
      onChange={onSearchChange}
      aria-label="Search roster by name or ServiceTitan ID"
      placeholder="Search name or ID"
      className="max-w-full shrink-0"
    />
    {(filterFields.length > 0 || teams.length > 1 || teamIds.length > 0) && (
      <Stack align="start" gap={0} className="min-w-0 flex-1 basis-lg">
        <RosterFilterControls
          filterFields={filterFields}
          leadingFilter={
            <TeamFilter
              teams={teams}
              value={teamIds}
              onChange={onTeamIdsChange}
            />
          }
          filters={filters}
          onChange={onFiltersChange}
        />
      </Stack>
    )}
  </Stack>
);
